import { render, staticRenderFns } from "./index-staff-v2.vue?vue&type=template&id=6dd2598b"
import script from "./index-staff-v2.vue?vue&type=script&lang=js"
export * from "./index-staff-v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports